import { makeAutoObservable } from 'mobx';
import { RootStore } from '../RootStore';

export class PopupStore {
  rootStore: RootStore;
  isNewHospitalOpen: boolean = false;
  isNewManuelRowOpen: boolean = false;
  isNewQrCodeRowOpen: boolean = false;
  isEditManuelRowOpen: boolean = false;
  isSwitchHospitalOpen: boolean = false;
  isQrCodeOriginalDataOpen: boolean = false;
  isDeleteConfirmationOpen: boolean = false;
  isNewKnRowOpen: boolean = false;
  isEditUserOpen: boolean = false; // User Management için eklendi
  isNewUserOpen: boolean = false; // User Management için eklendi
  isDeleteUserConfirmationOpen: boolean = false; // User Management için eklendi
  isNewTagOpen: boolean = false;
  isEditHospitalOpen: boolean = false; // Hastane düzenleme için eklendi
  isSelectTagsOpen: boolean = false; // Etiket seçimi için eklendi
  isSearchTagByNumberOpen: boolean = false; // Etiket no ile arama popup
  isFilesDialogOpen: boolean = false; // Dosyalar popup için eklendi
  isNewOvertimeOpen: boolean = false; // Mesai ekleme için eklendi
  isEditOvertimeOpen: boolean = false; // Mesai düzenleme için eklendi
  isDeleteOvertimeConfirmationOpen: boolean = false; // Mesai silme onayı için eklendi
  isNewLeaveOpen: boolean = false; // İzin ekleme için eklendi
  isRejectionReasonOpen: boolean = false; // Red sebebi için eklendi
  isNewExpenseOpen: boolean = false; // Harcama ekleme için eklendi
  isEditExpenseOpen: boolean = false; // Harcama düzenleme için eklendi
  isExpenseDetailOpen: boolean = false; // Harcama detay için eklendi
  isDeleteExpenseConfirmationOpen: boolean = false; // Harcama silme onayı için eklendi
  isExportExcelOpen: boolean = false; // Excel export popup için eklendi
  isNewPersonOpen: boolean = false; // Yeni kişi ekleme için eklendi
  isEditPersonOpen: boolean = false; // Kişi düzenleme için eklendi
  isDeletePersonConfirmationOpen: boolean = false; // Kişi silme onayı için eklendi
  isNewAppointmentOpen: boolean = false; // Yeni randevu ekleme için eklendi
  isAppointmentForHospitalTagOpen: boolean = false; // Mevcut hastane/etiket için randevu
  isEditAppointmentOpen: boolean = false; // Randevu düzenleme için eklendi
  isDeleteAppointmentConfirmationOpen: boolean = false; // Randevu silme onayı için eklendi
  isAppointmentDetailOpen: boolean = false; // Randevu detay görüntüleme için eklendi
  isTodayRoutePopupOpen: boolean = false; // Bugünkü rota / Maps popup
  isSuggestionPopupOpen: boolean = false; // Öneri Gönder popup
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  setIsNewHospitalOpen = (value: boolean) => {
    this.isNewHospitalOpen = value;
  };

  setIsNewManuelRowOpen = (value: boolean) => {
    this.isNewManuelRowOpen = value;
  };

  setIsNewQrCodeOpen = (value: boolean) => {
    this.isNewQrCodeRowOpen = value;
  };

  setIsEditManuelRowOpen = (value: boolean) => {
    this.isEditManuelRowOpen = value;
  };

  setIsSwitchHospitalOpen = (value: boolean) => {
    this.isSwitchHospitalOpen = value;
  };

  setIsQrCodeOriginalDataOpen = (value: boolean) => {
    this.isQrCodeOriginalDataOpen = value;
  };

  setIsDeleteConfirmationOpen = (value: boolean) => {
    this.isDeleteConfirmationOpen = value;
  };

  setIsNewKnRowOpen = (value: boolean) => {
    this.isNewKnRowOpen = value;
  };

  // User Management için eklenen metodlar
  setIsEditUserOpen = (value: boolean) => {
    this.isEditUserOpen = value;
  };

  setIsNewUserOpen = (value: boolean) => {
    this.isNewUserOpen = value;
  };

  setIsDeleteUserConfirmationOpen = (value: boolean) => {
    this.isDeleteUserConfirmationOpen = value;
  };
  setIsNewTagOpen = (value: boolean) => {
    this.isNewTagOpen = value;
  };
  setIsEditHospitalOpen = (value: boolean) => {
    this.isEditHospitalOpen = value;
  };

  setIsSelectTagsOpen = (value: boolean) => {
    this.isSelectTagsOpen = value;
  };

  setIsSearchTagByNumberOpen = (value: boolean) => {
    this.isSearchTagByNumberOpen = value;
  };

  setIsFilesDialogOpen = (value: boolean) => {
    this.isFilesDialogOpen = value;
  };

  // Mesai popup'ları için eklenen metodlar
  setIsNewOvertimeOpen = (value: boolean) => {
    this.isNewOvertimeOpen = value;
  };

  setIsEditOvertimeOpen = (value: boolean) => {
    this.isEditOvertimeOpen = value;
  };

  setIsDeleteOvertimeConfirmationOpen = (value: boolean) => {
    this.isDeleteOvertimeConfirmationOpen = value;
  };

  setIsNewLeaveOpen = (value: boolean) => {
    this.isNewLeaveOpen = value;
  };

  setIsRejectionReasonOpen = (value: boolean) => {
    this.isRejectionReasonOpen = value;
  };

  // Harcama popup'ları için eklenen metodlar
  setIsNewExpenseOpen = (value: boolean) => {
    this.isNewExpenseOpen = value;
  };

  setIsEditExpenseOpen = (value: boolean) => {
    this.isEditExpenseOpen = value;
  };

  setIsExpenseDetailOpen = (value: boolean) => {
    this.isExpenseDetailOpen = value;
  };

  setIsDeleteExpenseConfirmationOpen = (value: boolean) => {
    this.isDeleteExpenseConfirmationOpen = value;
  };

  setIsExportExcelOpen = (value: boolean) => {
    this.isExportExcelOpen = value;
  };

  // Kişiler popup'ı için eklenen metodlar
  setIsNewPersonOpen = (value: boolean) => {
    this.isNewPersonOpen = value;
  };

  setIsEditPersonOpen = (value: boolean) => {
    this.isEditPersonOpen = value;
  };

  setIsDeletePersonConfirmationOpen = (value: boolean) => {
    this.isDeletePersonConfirmationOpen = value;
  };

  // Randevular popup'ı için eklenen metodlar
  setIsNewAppointmentOpen = (value: boolean) => {
    this.isNewAppointmentOpen = value;
  };

  setIsAppointmentForHospitalTagOpen = (value: boolean) => {
    this.isAppointmentForHospitalTagOpen = value;
  };

  setIsEditAppointmentOpen = (value: boolean) => {
    this.isEditAppointmentOpen = value;
  };

  setIsDeleteAppointmentConfirmationOpen = (value: boolean) => {
    this.isDeleteAppointmentConfirmationOpen = value;
  };

  setIsAppointmentDetailOpen = (value: boolean) => {
    this.isAppointmentDetailOpen = value;
  };

  setIsTodayRoutePopupOpen = (value: boolean) => {
    this.isTodayRoutePopupOpen = value;
  };

  setIsSuggestionPopupOpen = (value: boolean) => {
    this.isSuggestionPopupOpen = value;
  };

  // Herhangi bir popup açık mı kontrolü
  get isAnyPopupOpen(): boolean {
    return (
      this.isNewHospitalOpen ||
      this.isNewManuelRowOpen ||
      this.isNewQrCodeRowOpen ||
      this.isEditManuelRowOpen ||
      this.isSwitchHospitalOpen ||
      this.isQrCodeOriginalDataOpen ||
      this.isDeleteConfirmationOpen ||
      this.isNewKnRowOpen ||
      this.isEditUserOpen ||
      this.isNewUserOpen ||
      this.isDeleteUserConfirmationOpen ||
      this.isNewTagOpen ||
      this.isEditHospitalOpen ||
      this.isSelectTagsOpen ||
      this.isSearchTagByNumberOpen ||
      this.isFilesDialogOpen ||
      this.isNewOvertimeOpen ||
      this.isEditOvertimeOpen ||
      this.isDeleteOvertimeConfirmationOpen ||
      this.isNewLeaveOpen ||
      this.isRejectionReasonOpen ||
      this.isNewExpenseOpen ||
      this.isEditExpenseOpen ||
      this.isExpenseDetailOpen ||
      this.isDeleteExpenseConfirmationOpen ||
      this.isExportExcelOpen ||
      this.isNewPersonOpen ||
      this.isEditPersonOpen ||
      this.isDeletePersonConfirmationOpen ||
      this.isNewAppointmentOpen ||
      this.isAppointmentForHospitalTagOpen ||
      this.isEditAppointmentOpen ||
      this.isDeleteAppointmentConfirmationOpen ||
      this.isAppointmentDetailOpen ||
      this.isTodayRoutePopupOpen ||
      this.isSuggestionPopupOpen
    );
  }
}
